export default __webpack_public_path__ + "static/media/home-title-junior.2c190c19.png";